import { useRef, useState } from 'react'
import Popup from "../../popup"
import TextArea from '@/components/formFields/TextArea'
import useForm from '@/Hooks/useForm'

const TextPopup = ({ onApply, textRef }) => {
const {formHandler} = useForm()

  const [text, setText] = useState("")

  return (
    <>
      <Popup needbtn={!!onApply} onApply={() => onApply(text)} large={false} title={"reject-request"} name={`img-${Date.now()}`} modalID={textRef}>
        <TextArea  isRequired min={10} max={1500} className={"col-lg-12"} label="reject-note"  name="note" value={text} setValue={(value) => setText(value)} formHandler={formHandler} />
      </Popup>
    </>
  )
}

export default TextPopup